type FilterFunction<T> = (
  _items: T[],
  _prop: keyof T,
  _filterValue: string,
) => T[];

export const filterExact: FilterFunction<any> = <T>(
  items: T[],
  prop: keyof T,
  filterValue: string,
): T[] => {
  if (!filterValue) return items;

  return items.filter((item) => item[prop] === filterValue);
};

export const filterIncludes: FilterFunction<any> = <T>(
  items: T[],
  prop: keyof T,
  filterValue: string,
): T[] => {
  if (!filterValue) return items;

  return items.filter((item) => item[prop]?.toString().includes(filterValue));
};
